import { useState } from "react";
import { ArrowUpRight, Check, Copy } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

export const ContractPanel = ({ label, address, scanUrl, scanLabel, testId }) => {
    const { t } = useLanguage();
    const [copied, setCopied] = useState(false);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(address);
            setCopied(true);
            setTimeout(() => setCopied(false), 2200);
        } catch {}
    };

    return (
        <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-nx-soft/80 p-6 backdrop-blur-sm lg:p-7" data-testid={testId}>
            <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-nx-blue/10 blur-[50px] rtl:-left-10 rtl:right-auto" aria-hidden="true" />
            <span className="relative text-[11px] font-bold uppercase tracking-[0.2em] text-nx-lime">{t(label)}</span>
            <div className="relative mt-5 space-y-4">
                <div>
                    <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-nx-mute">{t("Network")}</span>
                    <p className="mt-1 flex items-center gap-2 text-sm font-bold text-nx-text">
                        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-nx-blue" aria-hidden="true" />
                        BNB Smart Chain / BEP20
                    </p>
                </div>
                <div>
                    <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-nx-mute">{t("Contract")}</span>
                    <p className="mt-1 break-all font-mono text-[13px] leading-relaxed text-nx-sub" dir="ltr" data-testid={`${testId}-address`}>
                        {address}
                    </p>
                </div>
            </div>
            <div className="relative mt-6 flex flex-wrap items-center gap-3">
                <button
                    type="button"
                    onClick={copy}
                    data-testid={`${testId}-copy`}
                    className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-nx-elev px-4 py-2 text-xs font-bold text-nx-sub transition-all duration-300 hover:border-white/20 hover:text-nx-text focus:outline-none focus:ring-2 focus:ring-nx-lime"
                >
                    {copied ? <Check size={13} strokeWidth={2} className="text-nx-lime" aria-hidden="true" /> : <Copy size={13} strokeWidth={1.5} aria-hidden="true" />}
                    <span className={copied ? "text-nx-lime" : ""}>{copied ? t("Copied") : t("Copy Contract")}</span>
                </button>
                <a
                    href={scanUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`${testId}-scan`}
                    className="group inline-flex items-center gap-1.5 rounded-full border border-nx-blue/40 bg-nx-blue/[0.08] px-4 py-2 text-xs font-bold text-nx-blue transition-all duration-300 hover:bg-nx-blue/[0.15] hover:-translate-y-px"
                >
                    {t(scanLabel)}
                    <ArrowUpRight size={13} strokeWidth={2} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
                </a>
            </div>
        </div>
    );
};
